<template>
  <div class="friendTransfer">
    <common-title titleName="亲友专享优惠" :bcColor="'#F7F8FC'" :isAPPShow="true"></common-title>
    <div class="active_info">
      <img class="active_info_img" :src="basicInfo.relativeImg" alt />
    </div>
    <div class="botton">
      <div class="bottom_btn" @click="onOpenMini">打开启航考研小程序参与活动</div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { reqSchemeUrl } from '@/api/openMini';
import { reqInvitationInfo } from '@/api/invitationCommission';
import { setBaseUrl } from '@/utils/tools';

export default {
  data() {
    return {
      agentId: this.$route.query?.agentId || '',
      basicInfo: {},
    };
  },
  beforeCreate() {
    console.log('beforeCreate');
  },
  created() {
    console.log('created');
  },
  beforeMount() {
    console.log('beforeMount');
  },
  mounted() {
    this.getInvitationInfo();
  },
  methods: {
    getInvitationInfo() {
      reqInvitationInfo().then(res => {
        console.log('res', res);
        this.basicInfo = res;
      });
    },
    onOpenMini() {
      // h5 打开小程序的方法
      console.log(!window.location.host.includes('mobile-test') ? 'release' : 'trial');
      const data = {
        appid: 'wxdb89cfa2bb60f779',
        path: '/subPackages/webView/webView',
        query: `url=${encodeURIComponent(`${setBaseUrl(2)}/ark/invitation/friendReceive?id=${this.agentId}&source=agent&clearToken=clearToken`)}`,
        envVersion: window.location.host.includes('mobile.iqihang') ? 'release' : 'trial',
        // envVersion: 'trial',
      };

      reqSchemeUrl(data).then(res => {
        if (res?.code === 0) {
          this.chatUrl = res.data;
          window.location.href = res.data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.friendTransfer {
  padding-top: 100px;
  overflow: hidden;

  .active_info {
    width: 678px;
    // height: 3000px;
    margin: 36px auto 177px;
    // overflow: hidden;

    .active_info_img {
      width: 100%;
      height: 100%;
      border-radius: 18px;
    }
  }

  .botton {
    position: fixed;
    bottom: 0;
    width: 750px;
    height: 167px;
    background: #fff;
    border-radius: 22px 22px 2px 2px;
    box-shadow: 0 -4 14px 0 rgba(0, 0, 0, 0.05);

    .bottom_btn {
      width: 678px;
      height: 80px;
      margin: 22px auto;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      font-family: PingFangSC, PingFang SC, sans-serif;
      line-height: 80px;
      text-align: center;
      background: #ff7f41;
      border-radius: 49px;
    }
  }
}
</style>
